const SortItems = (prev, curr, columnId) => {
  var prevCol = String(prev.original[columnId])
  var currCol = String(curr.original[columnId])
  if (prevCol.toLowerCase() > currCol.toLowerCase()) {
    return 1
  } else if (prevCol.toLowerCase() < currCol.toLowerCase()) {
    return -1
  } else {
    return 0
  }
}

export default SortItems
